// src/components/common/ScrollReveal.js
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

function ScrollReveal({ children, delay = 0 }) {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  return (
    <motion.div
      ref={ref}
      initial={{ 
        opacity: 0,
        y: 50
      }}
      animate={{ 
        opacity: inView ? 1 : 0,
        y: inView ? 0 : 50
      }}
      transition={{
        duration: 0.8,
        delay: delay,
        ease: "easeOut"
      }}
    >
      {children}
    </motion.div>
  );
}

export default ScrollReveal;